import Form from "react-bootstrap/Form";
import Avatar from "../../../src/Assets/images/avatar.png";
import { Col, Row } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import * as React from "react";
import { useForm } from "react-hook-form";
import { useEffect, useState } from "react";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import { fetchData } from "./Utilities";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";

export const BannerSetBox = ({ position }) => {
  const [initialValues, setIntialValues] = useState([]);
  const [Logo, setLogo] = useState("");
  const defaultValues = {
    title: "",
    link: "",
    img: "",
    sort: "",
    BannerId: "",
  };

  useEffect(() => {
    fetchData("banner", {}, handleApiResponse);
  }, []);
  const handleApiResponse = (data) => {
    const initData = data?.dt?.filter((img) =>
      position === 1 ? img.Position === 1 : img.Position === 2
    )[0];
    setIntialValues(initData);
    reset({ ...initData });
  };
  const {
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = useForm({ defaultValues });

  const onSubmit = async (data, image) => {
    const bodyFormData = new FormData();
    bodyFormData.append("bannerId", data?.BannerId || 0);
    bodyFormData.append("position", position);
    bodyFormData.append("title", data?.title);
    bodyFormData.append("link", data?.link);
    bodyFormData.append("sort", data?.sort);
    bodyFormData.append("image", image);
    bodyFormData.append("guid", Cookies.get("guid"));
    fetchData("updatebanner", bodyFormData, handleApiResponse);
    const handleApiResponse = async (data) => {
      SweetAlert({
        title: "",
        text: "اطلاعات اولیه با موفقیت ذخیره شد.",
        type: "success",
      });
    };
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "updatebanner",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        SweetAlert({
          title: "",
          text: "اطلاعات اولیه با موفقیت ذخیره شد.",
          type: "success",
        });
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      throw new Error("Cpanel private route Error: ", error.message);
    }
  };

  const handleUpload = async (w, h, sednFile, data) => {
    if (!sednFile) {
      return;
    }
    const image = new Image();
    image.src = sednFile;
    const cWith = w;
    const cHeight = h;
    let percentWidth = 0;
    let percentHeight = 0;

    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const orginalWidht = image.naturalWidth;
      const orginalHeight = image.naturalHeight;
      if (cWith === 0 || cHeight === 0) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      } else {
        percentWidth = cWith / orginalWidht;
        percentHeight = cHeight / orginalHeight;
        const percent =
          percentHeight < percentWidth ? percentHeight : percentWidth;
        canvas.width = image.naturalWidth * percent;
        canvas.height = image.naturalHeight * percent;
      }

      canvas
        .getContext("2d")
        .drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(async (blob) => {
        const myImage = new File([blob], "my-new-name.webp", {
          type: blob.type,
        });
        onSubmit(data, myImage);
      }, "image/webp");
    };
  };
  const handleSendImage = (data) => {
    const width = 800;
    const height = 800;
    handleUpload(width, height, Logo, data);
  };

  return (
    <div className="">
      <div className="panel panel-primary">
        <Form dir="rtl" onSubmit={handleSubmit(handleSendImage)}>
          <div className="panel-heading prime-bg text-white text-center p-2">
            <span id="ContentPlaceHolder1_lblbannerheading">{`بنر چپ ${
              position === 1 ? "بالا" : "پایین"
            }`}</span>
          </div>
          <div className="panel-body">
            <div className="row d-flex justify-content-between align-items-center ">
              <Row>
                <Col className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="sort"
                    type={"tel"}
                    defaultValue={""}
                    label="اولویت"
                    errors={errors}
                  />
                </Col>
                <Col className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="title"
                    type={"text"}
                    label="عنوان "
                    errors={errors}
                  />
                </Col>
              </Row>

              <Row>
                <Col className="col-12 col-lg-6">
                  <InputFormat
                    control={control}
                    name="link"
                    type={"text"}
                    label="لینک"
                    errors={errors}
                  />
                </Col>
                <Col className="col-12 col-lg-6">
                  <img
                    onClick={() => document.getElementById("fileInput").click()}
                    className="banner-set-image rounded"
                    alt="انتخاب عکس بنر"
                    src={
                      !Logo
                        ? `https://api.taab30.com${initialValues?.img}` || ""
                        : Logo
                    }
                  />
                  <input
                    type="file"
                    id="fileInput"
                    className="d-none"
                    onChange={(e) => {
                      if (e.target.files.length > 0) {
                        setLogo(URL.createObjectURL(e.target.files[0]));
                      }
                    }}
                  />
                </Col>
              </Row>
              <br />
              <Row>
                <Col className="col-12 col-lg-12">
                  <div className="d-flex flex-row flex-wrap justify-content-center align-items-center gap-1">
                    <Button
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                      className="btn btn-warning"
                      type="button"
                    >
                      انتخاب عکس
                    </Button>
                    <Button type="submit">ذخیره</Button>
                  </div>
                </Col>
              </Row>
            </div>
          </div>
        </Form>
      </div>
    </div>
  );
};
